import Ajax from '@utils/ajax';

export function postDeductionMigrationModalData(data) {
	return Ajax.post('/settings/new_benefit/deduction_migration', data);
}
